module.exports = __webpack_public_path__ + "assets/img/anquan.a76d9db7.png";